import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Bell, CalendarCheck, Briefcase, Mic, Users, Menu } from "lucide-react";
import { useAlertCount } from "@/lib/useAlertCount";
import { AppHeader } from "@/components/layout/AppHeader";
import { NamtechFooter } from "@/components/poc/NamtechFooter";
import { QueueIndicator } from "@/components/conecta/QueueIndicator";
import { useReviewCount } from "@/lib/useReviewCount";

const TABS = [
  { to: "/conecta", key: "hoy", label: "Hoy", icon: CalendarCheck, end: true },
  { to: "/conecta/negocios", key: "negocios", label: "Negocios", icon: Briefcase },
  { to: "/conecta/grabar?auto=1", key: "grabar", label: "Grabar", icon: Mic, center: true },
  { to: "/conecta/red", key: "red", label: "Red", icon: Users },
  { to: "/conecta/mas", key: "mas", label: "Más", icon: Menu },
];

const BottomNav = ({ badge }) => (
  <nav data-testid="conecta-bottom-nav" className="fixed bottom-0 inset-x-0 z-40 border-t c-line bg-[color-mix(in_srgb,var(--c-card)_92%,transparent)] backdrop-blur-xl pb-[env(safe-area-inset-bottom)]">
    <div className="max-w-md mx-auto grid grid-cols-5 items-end h-16">
      {TABS.map(({ to, key, label, icon: Icon, end, center }) => (
        <NavLink key={key} to={to} end={end} data-testid={`conecta-nav-${key}`}
          className={({ isActive }) => `flex flex-col items-center justify-end gap-1 pb-2 text-[11px] font-semibold transition-colors ${isActive ? "c-accent" : "c-muted"}`}>
          {center ? (
            <span className="-mt-8 mb-0.5 w-16 h-16 rounded-full bg-[#dc2626] text-white flex items-center justify-center shadow-lg shadow-red-900/30 ring-4 ring-[var(--c-bg)] active:scale-95 transition-transform">
              <Icon className="w-7 h-7" />
            </span>
          ) : (
            <span className="relative">
              <Icon className="w-5 h-5" />
              {key === "mas" && badge > 0 && <span data-testid="nav-review-badge" className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#dc2626] text-white text-[10px] font-bold flex items-center justify-center">{badge}</span>}
            </span>
          )}
          {label}
        </NavLink>
      ))}
    </div>
  </nav>
);

const TITLES = { negocios: "Negocios", grabar: "Grabar", red: "Red", mas: "Más", comisiones: "Comisiones y cobros", capturas: "Confirmar captura", revisar: "Por revisar", necesidades: "Necesidades", alertas: "Alertas", cruce: "Dame una opción", config: "Configuración", "mi-red": "Mi red CONECTA", invitaciones: "Mis invitaciones", u: "Perfil en la red", buscar: "Buscar en la red", solicitudes: "Mis solicitudes", avisos: "Notificaciones", actividad: "Mi actividad en la red" };

const AlertBell = () => {
  const count = useAlertCount();
  return (
    <Link to="/conecta/alertas" aria-label="Alertas" data-testid="header-alerts-btn" className="relative w-10 h-10 rounded-full flex items-center justify-center c-card hover:opacity-80 transition-opacity">
      <Bell className="w-5 h-5" />
      {count > 0 && <span data-testid="header-alerts-badge" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#dc2626] text-white text-[10px] font-bold flex items-center justify-center">{count}</span>}
    </Link>
  );
};

export default function ConectaLayout() {
  const { pathname } = useLocation();
  const reviewCount = useReviewCount();
  return (
    <div data-testid="conecta-layout" className="min-h-screen max-w-md mx-auto flex flex-col pb-24">
      <AppHeader eyebrow="CONECTA" title={TITLES[pathname.split("/")[2]] || "Hoy"} showLogout right={<AlertBell />} />
      <QueueIndicator />
      <main className="flex-1 px-4 pt-2"><Outlet /></main>
      <div className="px-4"><NamtechFooter /></div>
      <BottomNav badge={reviewCount} />
    </div>
  );
}
